<template>
    <div class="Auth p5 mt-5">
        <div class="row">
            <div class="col-sm-6 col-md-3 mx-auto">
                <div class="login-header d-flex justify-content-between">
<!--                    <img src="@/assets/images/logo.png" width="120" />-->
                    <span>{{translate.trans('pinker.loginTitle')}}</span>
                </div>
                <form class="form-horizontal mt-3 mb-3" onsubmit="return false">
                    <div v-if="errors.length" class="alert alert-warning">
                        <p v-for="(error,index) in errors" :key="index">
                            {{error}}
                        </p>
                    </div>
                    <div class="form-group">
                        <input id="email" v-model="input_email" class="form-control" name="email" :placeholder="translate.trans('pinker.login')">
                    </div>
                    <div class="form-group">
                        <input id="password" v-model="input_password" class="form-control" type="password" name="password" :placeholder="translate.trans('pinker.password')">
                    </div>
                    <div class="form-group d-flex align-items-center justify-content-between mt-4 mb-0">
                        <button type="submit" class="btn btn-warning w-100" @click="performLogin">
                            {{translate.trans('pinker.login')}}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import VueRouter from "vue-router";
import DibbleTranslation from "../../translation/translation";
import DibbleJs from '../../dibble';
import DibbleApi from '../../api';

Vue.use(require('vue-cookies'));
Vue.use(VueRouter)

export default {
    data() {
        return {
            translate: DibbleTranslation,
            errors: [],
            input_email: '',
            input_password: '',
        };
    },
    methods: {
        validateLoginForm() {
            this.errors = [];
            if (!this.input_email || !this.input_password) {
                this.errors.push(this.translate.trans('global.error.field.required'));
            }

            return !this.errors.length;
        },
        performLogin() {
            if (!this.validateLoginForm()) {
                return;
            }
            this.errors = [];
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.login,
                email: this.input_email,
                password: this.input_password
            };
            DibbleJs.callApiRequest(data, this._onPerformLoginSuccess)
        },
        _onPerformLoginSuccess(responseData) {
            DibbleJs.hideLoader();
            if (DibbleApi.isResponseSuccess(responseData)) {
                this.$cookies.set('_token', responseData.token, '1d');
                this.$cookies.set('_user', {
                    first_name: responseData.first_name,
                    last_name: responseData.last_name
                }, '1d');
                this.$router.push('users-list');
            } else {
                this.errors.push(responseData.message);
            }
        }
    }
};
</script>

<style>
    .Auth {
        color: #FFFFFF;
    }
</style>
